<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
</template>

<script>
export default {
  name: 'IconClose',
  props: {
    size: { type: [String, Number], default: 14 },
    strokeWidth: { type: [String, Number], default: 2.5 },
  },
};
</script>
